<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle
          :title="$t('page_title.white')"
          :newButShow="true"
          @newBut="newBut('add')"
        ></pageTitle>
        <myTableFilter @submit="handleSubmit" :show="{ email: true }" />
        <myTable ref="table" :columns="columns" requestUrl="school-white/list" :showPage="true">
          <template v-slot:action="{ data }">
            <Icon
              class="cursor_p"
              type="md-create"
              size="24"
              color="#1F8FC8"
              @click="newBut('edit',data.row)"
            />
            <Poptip
              placement="bottom"
              confirm
              :title="$t('confirm_delete')"
              @on-ok="handleDel(data.row)"
            >
              <Icon class="cursor_p mg-left15" type="md-trash" size="24" color="#7D7C7F" />
            </Poptip>
          </template>
          <template v-slot:reg_image="{ data }">
            <div class="imgList">
              <img :src="data.row.reg_image" />
            </div>
          </template>
        </myTable>
      </div>
    </div>
    <edit
      v-if="modal"
      @onOk="onOk"
      :type="type"
      :modal="modal"
      :itemObj="itemObj"
      @cancel="cancel"
    ></edit>
  </div>
</template>

<script>
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";
import myTableFilter from "@/components/myTableFilter";
import edit from "./module/white_edit";
export default {
  name: "white",
  components: {
    myTable,
    pageTitle,
    myTableFilter,
    edit
  },
  data () {
    return {
      columns: [
        {
          title: this.$t("Info.code"),
          key: "white_id",
          align: "center",
          width: 100,
        },
        
        {
          title: this.$t("email"),
          key: "email",
          align: "center"
        },
        {
          title: this.$t("cms_email.addTime"),
          key: "add_time",
          align: "center"
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "action",
          width: 100,
        },
      ],
      modal: false,
      itemObj: {},
      type: "add",
    };
  },
  created () {
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },

    newBut (type, item) {
      this.type = type
      this.itemObj = item
      this.modal = true
    },
    cancel () {
      this.modal = false
    },
    onOk () {
      this.$base.msgSuccess(this.$t("op_ok"));
      this.$refs.table.getLoad();
    },
    handleDel (item) {
      this.$base.showLoading();
      this.$request.sendPost(
        'school-white/del',
        { white_id: item.white_id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          this.$refs.table.getLoad();
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-table-cell-slot {
  display: flex;
  justify-content: center;
}
.imgList {
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .table-box {
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/school/white/white.vue